import React, { useState } from "react";
import PropTypes from "prop-types";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import {
  Tab,
  TabContext,
  TabList,
  TabPanel,
  TabPanels,
} from "discover.medical.react-component-library";
import AlertItems from "./AlertItems";
import { Divider } from "./_.styled";

const AlertList = ({ all, followed, className, ...props }) => {
  const [activeTab, setActiveTab] = useState(0);
  const configData = useConfig();
  const isPersonalized = configData?.header.userDetails.state.personalized;

  // if the user has followed alerts show tabbed interface
  if (followed?.unfiltered?.length > 0) {
    return (
      <TabContext activeTab={activeTab}>
        <TabList
          aria-label="followed & all topics"
          onChange={(e, idx) => setActiveTab(idx)}
          {...props}
        >
          <Tab label="Followed" />
          <Tab label="All Topics" />
        </TabList>
        <Divider noMargin={true} />
        <TabPanels>
          <TabPanel>
            <AlertItems alerts={followed} />
          </TabPanel>
          <TabPanel>
            <AlertItems alerts={all} />
          </TabPanel>
        </TabPanels>
      </TabContext>
    );
  } else {
    // otherwise they either are not personalized or are following nothing
    // show only the site "all" alerts, no tabs
    return (
      <AlertItems
        className={className}
        alerts={all}
        renderSubscribeCard={!isPersonalized}
        {...props}
      />
    );
  }
};

AlertList.propTypes = {
  followed: PropTypes.array,
  all: PropTypes.array,
};

export default AlertList;
